var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CompetitorList"},_vm._l((_vm.list),function(player){return _c('row',{key:player.id,staticClass:"Player animated",attrs:{"data":player,"stagger":"100","enter-active-class":"animated flipInX","leave-active-class":"animated fadeOutLeft"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }